import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import {
  EdMessage,
  EdMessageThread,
  EdMessagesApi,
  EdSendMessageRequest,
} from '../tokens/ed-messages.token';

/**
 * REST implementation of the E-D two-way messaging API (PRD §3.15, EM-778). Bound to `ED_MESSAGES`.
 *
 *   GET  /services/embedded/api/v1/messages/threads
 *   GET  /services/embedded/api/v1/messages/threads/{threadId}
 *   POST /services/embedded/api/v1/messages
 *
 * Self-scoped server-side (Rule 22). REST-only (Rules 07/10). Errors (incl. the MSG_RULES 403)
 * propagate raw for the caller to surface via `extractBackendErrorMessage` (Rule 09).
 */
@Injectable({ providedIn: 'root' })
export class EdMessagesRestService implements EdMessagesApi {
  private readonly http = inject(HttpClient);
  private readonly base = `${API_PATHS.EMBEDDED_API_BASE}/v1/messages`;

  listThreads(): Observable<EdMessageThread[]> {
    return this.http.get<EdMessageThread[]>(`${this.base}/threads`);
  }

  getThread(threadId: string): Observable<EdMessageThread> {
    return this.http.get<EdMessageThread>(`${this.base}/threads/${encodeURIComponent(threadId)}`);
  }

  send(request: EdSendMessageRequest): Observable<EdMessage> {
    return this.http.post<EdMessage>(this.base, request);
  }
}
